import _ from 'underscore';

export function isUSorCanada(countryLocationData) {
  if (_.size(countryLocationData) !== 2) {
    return false;
  }

  return _.every(countryLocationData, (country: any) =>
    (country.CountryLatitude > 62 && country.CountryLatitude < 64 && country.CountryLongitude > -97 && country.CountryLongitude < -95) ||// Canada
    (country.CountryLatitude > 39 && country.CountryLatitude < 41 && country.CountryLongitude > -100 && country.CountryLongitude < -98));// US
}
